import React from "react";
import { Box, Stat, StatLabel, StatNumber, StatHelpText } from "@chakra-ui/react";
import { useCustomTheme } from "../../../contexts/CustomThemeContext";

type AdminMetricCardProps = {
    label: string;
    value: React.ReactNode;
    helpText?: React.ReactNode;
    accent?: string;
    gradientBg?: string;
};

export const AdminMetricCard: React.FC<AdminMetricCardProps> = ({
    label,
    value,
    helpText,
    accent,
    gradientBg,
}) => {
    const { theme } = useCustomTheme();
    const isDark = theme.name === "dark";

    const brand = theme.brand || {
        electricBlue: "#27b7ff",
    };

    const cardsBorderRadii = "8px";
    const finalAccent = accent || brand.electricBlue;

    return (
        <Box
            borderRadius={cardsBorderRadii}
            bg={
                gradientBg ||
                (isDark
                    ? "linear-gradient(135deg, rgba(39,183,255,0.10), rgba(73,209,255,0.03))"
                    : "linear-gradient(135deg, rgba(39,183,255,0.10), rgba(73,209,255,0.04))")
            }
            boxShadow={theme.shadowSm}
            border={`1px solid ${theme.border}`}
            p={4}
            position="relative"
            overflow="hidden"
            _before={{
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "3px",
                bg: finalAccent,
            }}
        >
            <Stat>
                <StatLabel color={theme.textMuted}>{label}</StatLabel>
                <StatNumber color={theme.text}>{value}</StatNumber>
                {helpText ? <StatHelpText color={theme.textSubtle}>{helpText}</StatHelpText> : null}
            </Stat>
        </Box>
    );
};